import React, { useState, useEffect } from "react";
import { Menu, X, CalendarCheck, ShieldCheck } from "lucide-react";
import Logo from "./Logo";
import { navLinks, clinic } from "../mock";
import { useBooking } from "../App";
import { Button } from "./ui/button";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { openBooking } = useBooking();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-md border-b border-slate-200 shadow-[0_6px_24px_-16px_rgba(11,37,69,0.4)]"
          : "bg-transparent"
      }`}
    >
      <nav className="max-w-7xl mx-auto px-5 lg:px-8 h-[74px] flex items-center justify-between">
        <button onClick={() => handleNav("#inicio")} aria-label="Inicio">
          <Logo light={!scrolled} />
        </button>

        <div className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <button
              key={l.href}
              onClick={() => handleNav(l.href)}
              className={`link-underline text-sm font-medium transition-colors ${
                scrolled ? "text-slate-700 hover:text-blue-600" : "text-white/85 hover:text-white"
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={clinic.panelUrl}
            target="_blank"
            rel="noopener noreferrer"
            className={`inline-flex items-center gap-2 text-sm font-medium px-4 py-2 rounded-full border transition-all ${
              scrolled
                ? "border-slate-300 text-slate-700 hover:border-blue-500 hover:text-blue-600"
                : "border-white/30 text-white hover:bg-white/10"
            }`}
          >
            <ShieldCheck size={16} /> Panel Clínico
          </a>
          <Button
            onClick={openBooking}
            className="rounded-full bg-[#1d6fc0] hover:bg-[#175a9e] text-white px-5 shadow-lg shadow-blue-900/20"
          >
            <CalendarCheck size={16} className="mr-1.5" /> Reservar Hora
          </Button>
        </div>

        <button
          className={`lg:hidden p-2 rounded-lg ${scrolled ? "text-slate-800" : "text-white"}`}
          onClick={() => setOpen((o) => !o)}
          aria-label="Menú"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </nav>

      {/* Mobile */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 bg-white border-b border-slate-200 ${
          open ? "max-h-[420px]" : "max-h-0"
        }`}
      >
        <div className="px-5 py-4 flex flex-col gap-1">
          {navLinks.map((l) => (
            <button
              key={l.href}
              onClick={() => handleNav(l.href)}
              className="text-left py-2.5 text-slate-700 font-medium border-b border-slate-100"
            >
              {l.label}
            </button>
          ))}
          <a
            href={clinic.panelUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 py-2.5 text-slate-700 font-medium"
          >
            <ShieldCheck size={16} /> Panel Clínico
          </a>
          <Button
            onClick={() => {
              setOpen(false);
              openBooking();
            }}
            className="mt-2 rounded-full bg-[#1d6fc0] hover:bg-[#175a9e] text-white"
          >
            <CalendarCheck size={16} className="mr-1.5" /> Reservar Hora
          </Button>
        </div>
      </div>
    </header>
  );
}
